import React from 'react';
import classnames from 'classnames';
import DeviationTorpedo from '../../../Torpedo/DeviationTorpedo';
import DeviationDuperbrowseContext from '../../../Duperbrowse/DeviationDuperbrowseContext';
import { MeasuredCookieType } from '../../../Measured';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import s from './DeviationSidebarTorpedo.scss';
var defaultDims = { width: 375, height: 358 };
var DeviationSidebarTorpedo = function (_a) {
    var deviations = _a.deviations, parentDeviation = _a.parentDeviation, className = _a.className, title = _a.title, streamId = _a.streamId;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(DeviationDuperbrowseContext, { streamId: streamId, deviations: deviations, parent: {
                title: title || 'deviation',
                typeId: getDeviationResourceType(parentDeviation),
                itemId: parentDeviation.deviationId,
            } },
            React.createElement(DeviationTorpedo, { container: {
                    width: defaultDims.width,
                    height: defaultDims.height,
                }, maxRows: 2, items: deviations, cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR, cookieDim: "width", defaultSize: { desktop: defaultDims, mobile: defaultDims } }))));
};
DeviationSidebarTorpedo.displayName = 'DeviationSidebarTorpedo';
export default DeviationSidebarTorpedo;
//# sourceMappingURL=DeviationSidebarTorpedo.js.map